import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { cloneDeep, isEmpty, remove } from 'lodash';
import { DefaultColor } from '../../../../shared/helpers/app.constants';
import { MultiWellChartService } from '../../../../shared/services/charts';
import { TreatmentService } from '../../../../shared/services/treatment.service';
import { IWellItemPaging } from '../../../../shared/models/well.model';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CompareWellsService } from '../../../../shared/services/compare-wells.service';
import { Helper } from '../../../../shared/helpers/helper';

@Component({
  selector: 'app-cmw-wells-select-treatments',
  templateUrl: './cmw-wells-select-treatments.component.html',
  styleUrls: ['./cmw-wells-select-treatments.component.scss']
})
export class CmwWellsSelectTreatmentsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  destroy$: Subject<any> = new Subject();
  defaultColor: any[] = DefaultColor;
  listWellsData: any[] = [];
  isCompareSingleWell: boolean = false;
  private isShowWellAliasInTag: boolean = false;

  @Input()
  set showWellAliasInTag(value) {
    this.isShowWellAliasInTag = value;
  }

  get showWellAliasInTag() {
    return this.isShowWellAliasInTag;
  }

  @Input()
  set listWells(wells) {
    if (wells) {
      if (wells.length === 1) {
        this.isCompareSingleWell = true;
        this.showWellAliasInTag = false;
      } else {
        this.isCompareSingleWell = false;
        this.showWellAliasInTag = true;
      }
    }
    // init list if empty
    if (isEmpty(this.listWellsData)) {
      this.reloadListWells(wells);
    } else {
      // prevent re-render list
      this.listWellsData = this.listWellsData
        .map(well => {
          const wellItem = wells.find(item => item.wellId === well.wellId);
          if (wellItem) {
            well.treatment = wellItem.treatment || [];
            well.selectedTreatmentList = wellItem.selectedTreatmentList || [];
            well.treatmentList = wellItem.treatmentList || [];
          }
          return well;
        });
    }
  }

  @Output() wellTreatmentsChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private multiWellChartService: MultiWellChartService,
    private treatmentService: TreatmentService,
    private compareWellsService: CompareWellsService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$.unsubscribe();
    Helper.unsubscribe(this.subscriptions);
  }

  onEnter(value: string, item: IWellItemPaging) {
    if (item && value) {
      item.aliasName = value;
      this.multiWellChartService.onWellAliasNameChangeSubject.next(item);
      // update all data
      this.multiWellChartService.setWellOptionsData(this.listWellsData);

      this.treatmentService.updateWellAliasName(item.wellId, value)
        .pipe(takeUntil(this.destroy$))
        .subscribe();
    }
  }
  selectColor(item, color) {
    if (!item) return;
    item.wellColor = color;
    this.multiWellChartService.onWellAliasColorChangeSubject.next(item);
    this.multiWellChartService.setWellOptionsData(this.listWellsData);
    this.subscriptions.push(
      this.compareWellsService.updateWellColor(item.wellId, color).subscribe()
    );
  }
  selectedTreatment(e: any, wellItem) {
    const change = { id: e.id, text: e.text.replace('Treatment ', '') };
    const indexTreat = wellItem.treatment.findIndex(x => x.id === change.id);
    if (indexTreat !== -1) {
      remove(wellItem.treatment, { id: e.id });
      remove(wellItem.selectedTreatmentList, { id: e.id });
      wellItem.selectedTreatmentList = wellItem.selectedTreatmentList.slice();
    } else {
      wellItem.treatment.push(change);
      const treatment = { id: e.id, treatmentName: e.text };
      wellItem.selectedTreatmentList.push(treatment);
      wellItem.selectedTreatmentList = [...wellItem.selectedTreatmentList];
    }
    // emit event data
    this.emitEventData();
  }

  selectedAllTreatments(treatments, wellItem) {
    if (!treatments || !treatments.length) return;
    const tempTreatments = [];
    for (const i of treatments) {
      const find = tempTreatments.find(x => x.id === i.id);
      if (find) continue;
      tempTreatments.push(i);
    }

    treatments = tempTreatments;
    wellItem.treatment = treatments.map(item => {
      return { id: item.id, text: item.text.replace('Treatment ', '') };
    });
    wellItem.selectedTreatmentList = treatments.map(item => {
      return { id: item.id, treatmentName: item.text };
    });
    // emit event data
    this.emitEventData();
  }

  removeTreatment(e: any, all: boolean, wellItem) {
    if (all) {
      wellItem.treatment = [];
      wellItem.selectedTreatmentList = [];
    } else {
      remove(wellItem.treatment, { id: e.id });
      remove(wellItem.selectedTreatmentList, { id: e.id });
      wellItem.selectedTreatmentList = wellItem.selectedTreatmentList.slice();
    }
    // emit event data
    this.emitEventData();
  }

  reloadListWells(wells) {
    this.listWellsData = cloneDeep(wells);
    if (!isEmpty(this.listWellsData)) {
      this.listWellsData = this.listWellsData.map(item => {
        item.treatment = item.treatment || [];
        item.selectedTreatmentList = item.selectedTreatmentList || [];
        return item;
      });
    }
  }

  private emitEventData(): void {
    this.wellTreatmentsChange.emit(this.listWellsData);
  }

}
